module.exports = __webpack_public_path__ + "img/n_kazakov.da3e0929.jpg";